export default __webpack_public_path__ + "static/media/gallery-wip-pommel_05.3da26b76.jpg";